import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '@/store';

interface UserAccessState {
  typeForUserAccessLevel: string | null;
  freeTypeForUserAccessLevel: string | null;
}

const initialState: UserAccessState = {
  typeForUserAccessLevel: null,
  freeTypeForUserAccessLevel: null,
};

export const userAccessSlice = createSlice({
  name: 'userAccess',
  initialState,
  reducers: {
    setTypeForUserAccessLevel: (
      state,
      action: PayloadAction<string | null>
    ) => {
      state.typeForUserAccessLevel = action.payload;
    },
    setFreeTypeForUserAccessLevel: (
      state,
      action: PayloadAction<string | null>
    ) => {
      state.freeTypeForUserAccessLevel = action.payload;
    },
  },
});

export const { setTypeForUserAccessLevel, setFreeTypeForUserAccessLevel } =
  userAccessSlice.actions;

export const selectTypeForUserAccessLevel = (state: RootState) =>
  state.userAccess.typeForUserAccessLevel;
export const selectFreeTypeForUserAccessLevel = (state: RootState) =>
  state.userAccess.freeTypeForUserAccessLevel;

export default userAccessSlice.reducer;
